import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const StyledScheduleColumnHeader = styled.div<{ $isToday: boolean }>`
  ${({ theme: { kcc }, $isToday }): FlattenSimpleInterpolation => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    padding: ${kcc.spacing.XXS} 0 ${kcc.spacing.XXS} ${kcc.spacing.XS};

    .schedule-column-header__day-name {
      font-family: ${kcc.typography.FONT_FAMILY};
      font-size: ${kcc.typography.FONT_SIZE.BASE}px;
      font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      color: ${$isToday ? kcc.colors.PETROL[500] : kcc.colors.TEXT};
      text-transform: capitalize;
      margin: 0;
      line-height: 20px;
    }

    .schedule-column-header__day-number {
      font-family: ${kcc.typography.FONT_FAMILY};
      font-size: ${kcc.typography.FONT_SIZE.XXL}px;
      font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      color: ${$isToday ? kcc.colors.PETROL[500] : kcc.colors.TEXT};
      margin: 0;
      line-height: 29px;
    }
  `}
`;
